export class GridConfig {
    constructor(
        public hideFilters: boolean,
        public isInsidePanel: boolean,
        public defaultSortColumn: string,
        public rowKey: string,
        public statusValue: number,
        public enableRowSelection: boolean,
        public countByStatus: CountByStatus[],
        public suppressCellSelection: boolean,
        public suppressRowClickSelection: boolean,
        public isCheckAllAllowed: boolean,
        public gridTitle: string,
        public defaultSortOrder: string,
        public rowHeight: number,
        public noDataMessage: string,
        public headerHeight: number = 0,
        public rowClassRules: any,
        public isHoverRowColumnHighlight: boolean,
        public suppressRowHoverHighlight: boolean,
        public searchBarClass: any,
        public gridWrapperClass: string,
        public columnHoverHighlight: boolean,
        public gridHeaderMessage:string = "",
        public dataFilterValue: number = 0,
        public dataFilterTitle: string = "",
        public gridFilterPanelConfig: GridFilterPanelConfig = null,
        public gridTabConfig: GridTabConfig = null,
        public showFilter: boolean = true,
        public showSearch: boolean = true,
        public useClientSideRowModel: boolean = false,
        public suppressAllFilterOption: boolean = false
    ) {
    }

    public gridTitleClass: string = '';
    public gridTitleHyperlink: string = '';
    public cacheBlockSize: number = 100;
    public showTagTextValue: boolean = false;
}

export class CountByStatus {
    constructor(
        public className: string,
        public label: string,
        public count: number,
        public isClickEvent: boolean,
        public value: number        
    ) {        
    }
}
export class GridFilterPanelConfig{
    panelHeader: string;
    panelHeaderCount: number;
    sections: GridFilterPanelSection[];
}
export class GridFilterPanelSection {
    sectionHeader: string;
    sectionHeaderCount: number;
    sectionOptions: GridFilterPanelSectionOption[];
}
export class GridFilterPanelSectionOption {
   optionName: string;
   optionValue: number;
   optionCount: number;
   optionIcon: string;
}

export class GridTabConfig {
    tabs: GridTab[] = [];
    showWhenStatusValue: number;
}

export class GridTab {
    label: string;
    count: number;
    statusValue: number;
    isActive: boolean;
}
